import React, { memo, ReactNode } from 'react';
import { areEqual } from 'Utils/equalityChecks';

interface Props {
  dataId?: number;
  children: ReactNode;
  className?: string;
  tdClassName?: string;
  rowSpan?: number;
  onClick?: (e: any) => void;
  tdOnClick?: (e: any) => void;
}

const TableColumn = ({ dataId, children, className, rowSpan, tdClassName, onClick, tdOnClick }: Props) => (
  /* eslint-disable-next-line */
  <td
    className={tdClassName}
    role={tdOnClick ? 'button' : ''}
    data-id={dataId}
    rowSpan={rowSpan}
    onClick={tdOnClick}
    onKeyUp={tdOnClick}
  >
    {onClick ? (
      <div className={className} role="button" data-id={dataId} onClick={onClick} onKeyUp={onClick} tabIndex={0}>
        {children}
      </div>
    ) : (
      <div className={className}>{children}</div>
    )}
  </td>
);

TableColumn.defaultProps = {
  dataId: null,
  onClick: null,
  tdOnClick: null,
  rowSpan: null,
  className: undefined,
  tdClassName: undefined,
};

const TableColumnMemo = memo(TableColumn, areEqual);
export { TableColumnMemo as TableColumn };
